export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-shopping-cart-d341583c4e85aad7c58a343bc5830f00.svg";